import { IAppState, IFormControl } from '../../types';
import { validateDanishSsn } from './denmark/danish-ssn';
import { validateEstoniaSsn, getAge } from './estonia/esonian-ssn';
import { validateLatviaSsn } from './latvia/latvia-ssn';
import { validateLithuaniaSsn } from './lithuania/lithuania-ssn';
import { validateNorwegianIdNumber, possibleAgeOfPersonWithIdNumber } from './norway/norway-ssn';
import { validateSpanishSsn } from './spain/spain-ssn';
import { validationCodes, markets } from '../../constants';
import FinnishSSN from './finland/finland-ssn';
import SwedishSSN from './sweden/sweden-ssn';

import { calculateAge, getValidationMessage, getValidationRule } from '../allHelpers';

export function validateSsn(ctrl: IFormControl, appState: IAppState) {
    const control = ctrl;
    const { value } = control;
    const mustBeGreater = getValidationRule(control, validationCodes.mustBeGreater);
    const mustBeLess = getValidationRule(control, validationCodes.mustBeLess);
    let age: number = 0;

    switch (appState.formMeta.market) {
        case markets.denmark: {
            const validationDk = validateDanishSsn(value);
            control.isValid = validationDk.age !== 0;
            age = validationDk.age;
            break;
        }
        case markets.estonia:
            control.isValid = validateEstoniaSsn(value);
            age = getAge(value);
            break;
        case markets.finland: {
            const validationFn = FinnishSSN.parse(value);
            control.isValid = validationFn.valid;
            age = validationFn.ageInYears || 0;
            break;
        }
        case markets.germany:
            break;
        case markets.latvia: {
            const validationLv = validateLatviaSsn(value);
            control.isValid = validationLv && validationLv.isValid;
            age = validationLv ? calculateAge(validationLv.dateOfBirth) : 0;
            break;
        }
        case markets.lithuania: {
            const validationLt = validateLithuaniaSsn(value);
            control.isValid = validationLt && validationLt.isValid;
            age = validationLt ? calculateAge(validationLt.dateOfBirth) : 0;
            break;
        }
        case markets.norway: {
            control.isValid = validateNorwegianIdNumber(value);
            age = possibleAgeOfPersonWithIdNumber(value) || 0;
            break;
        }
        case markets.spain: {
            control.value = value.toUpperCase();
            control.isValid = validateSpanishSsn(control.value);
            break;
        }
        case markets.sweden: {
            control.isValid = SwedishSSN.isSSn(value);
            const date = SwedishSSN.getDateOfBirth(value);
            age = control.isValid && date ? calculateAge(date) : 0;
            break;
        }
        default:
            return;
    }

    if (!control.isValid) {
        control.validationMessage = getValidationMessage(control, validationCodes.invalid);
        return;
    }

    if (age && mustBeGreater && Number(mustBeGreater.value) > age) {
        control.isValid = false;
        control.validationMessage = mustBeGreater.message;
        return;
    }

    if (age && mustBeLess && Number(mustBeLess.value) < age) {
        control.isValid = false;
        control.validationMessage = mustBeLess.message;
    }
}
